import * as types from '../mutation-types'
import { getPlatformLaborEnabled } from '../../service/SystemService'
const state = {
  contractListObj: {  // 各平台协议
    0: {
      // 协议名
      title: '《趣学术平台播客及讲者协议》',
      // 版本号
      version: 'V4.0',
      // 提示信息
      message: '请勾趣学术平台播客及讲者协议',
      // 是否勾选
      isAgreeAgreement: false,
      // 哪个平台需要展示  平台，0：趣学术平台，1：高灯，2：人力家，3：奔奔，4: 火烧云，5.天富隆灵工, 6.白犀
      platForm: 0,
      // 协议类型，1：讲者认证协议，2：讲者签约协议
      agreementType: 1,
      // 协议详情地址/路由
      pageUrl: '/speaker/agree/489023264269311364',
      // 是否需要上传身份证
      isNeedCert: false,
      // 是否展示提示
      isTip: false,
      // 提示信息
      tipMessage: '',
      // 展示演示视频
      videoUrl: []
    },
    3: {
      title: '《共享经济合作伙伴协议》',
      version: 'V1.0',
      message: '请勾选共享经济合作伙伴协议',
      isAgreeAgreement: false,
      platForm: 3,
      agreementType: 2,
      pageUrl: '/partner/agree',
      isNeedCert: true,
      videoUrl: []
    },
    4: {
      title: '《自由职业者服务协议》',
      version: 'V1.0',
      message: '请勾选自由职业者服务协议',
      isAgreeAgreement: false,
      platForm: 4,
      agreementType: 2,
      pageUrl: '/labour/agree',
      isNeedCert: false,
      videoUrl: ['https://video.yaomaitong.cn/3004890295c371efba6f4531858c0102/30e39ec5bd9c4275bc5339656f9427b2-63fb9a62823a1c3ce9ad2301067571a5-ld.mp4']
    },
    5: {
      title: '《共享经济智能综合服务协议》',
      version: 'V1.0',
      message: '请勾选共享经济智能综合服务协议',
      isAgreeAgreement: false,
      platForm: 5,
      agreementType: 2,
      pageUrl: '/tianjin/agree',
      isNeedCert: true,
      videoUrl: []
    },
    6: {
      title: '《白犀自由职业者服务合作协议》',
      version: 'V1.0',
      message: '请勾选白犀自由职业者服务合作协议',
      isAgreeAgreement: false,
      platForm: 6,
      agreementType: 2,
      pageUrl: '/speaker/agree/512297554607370082',
      isNeedCert: true,
      videoUrl: []
    },
    7: {
      title: '《白犀自由职业者服务合作协议》',
      version: 'V1.0',
      message: '请勾选白犀自由职业者服务合作协议',
      isAgreeAgreement: false,
      platForm: 7,
      agreementType: 2,
      pageUrl: '/speaker/agree/566939153406901042',
      isNeedCert: true,
      videoUrl: []
    },
    8: {
      title: '《灵活就业合作伙伴协议》',
      version: 'V1.0',
      message: '请勾选灵活就业合作伙伴协议',
      isAgreeAgreement: false,
      platForm: 8,
      agreementType: 2,
      pageUrl: '/speaker/agree/618011508809239283',
      isNeedCert: false,
      isTip: true,
      tipMessage: '即将跳转第三方签约页面，提交签约后，将在1个工作日内完成审核',
      videoUrl: []
    },
    9: {
      title: '《自由职业者服务合作协议》',
      version: 'V1.0',
      message: '请勾选自由职业者服务合作协议',
      isAgreeAgreement: false,
      platForm: 9,
      agreementType: 2,
      pageUrl: '/speaker/agree/633465084608092568',
      isNeedCert: true,
      videoUrl: []
    }
  },
  platformLabor: false
}

const getters = {
  contractListObj: state => state.contractListObj,
  needAgreementObj: state => {
    const obj = {}
    const values = Object.values(state.contractListObj)
    values.forEach(item => {
      obj[`${item.platForm}-${item.agreementType}`] = {
        title: item.title,
        pageUrl: item.pageUrl
      }
    })
    return obj
  },
  platformLabor: state => state.platformLabor
}
const mutations = {
  [types.LABOUR_AGREE](state, {platForm, isAgreeAgreement}) {
    state.contractListObj[platForm].isAgreeAgreement = isAgreeAgreement
  },
  [types.SET_PLATFORM_LABOR_SERVICE](state, data) {
    state.platformLabor = data
  }
}

const actions = {
  // 是否同意劳务
  setLabourAgree({ commit }, data) {
    commit(types.LABOUR_AGREE, data)
  },
  getPlatformLaborServiceEnabled({ commit }) {
    getPlatformLaborEnabled().then(res => {
      commit(types.SET_PLATFORM_LABOR_SERVICE, res.data)
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
